import { render, staticRenderFns } from "./ReserveParking.vue?vue&type=template&id=63b1c4ec&scoped=true"
import script from "./ReserveParking.vue?vue&type=script&lang=js"
export * from "./ReserveParking.vue?vue&type=script&lang=js"
import style0 from "./ReserveParking.vue?vue&type=style&index=0&id=63b1c4ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b1c4ec",
  null
  
)

export default component.exports